/*
 *   Copyright (c) 2021 Novumare Technologies
 *   All rights reserved.
 */
import React, { Component } from 'react'

// components
import { connect } from 'react-redux';
import { isLogged } from 'actions/authAction';
import PhLast from './analysis/ph/PhLast';
import CondLast from './analysis/conductivity/CondLast';
import TdsLast from './analysis/tds/TdsLast';
import OrpLast from './analysis/orp/OrpLast';
import OxygenLast from './analysis/oxygen/OxygenLast';
import TempLast from './analysis/temp/TempLast';
import MainGraphic from './MainGraphic';
import MainLastScore from './MainLastScore';
import AllLastDosage from './dosage/AllLastDosage';
import TankStatus from './TankStatus';


class Dashboard extends Component {
  componentDidMount() {
    this.props.isLogged(this.props.history);
  }
  render() {
    return (
      <>
        <div className="w-full mb-4">
          <div>
            <div className="flex flex-wrap">
              <div className="w-full md:w-6/12 lg:w-4/12 p-4">
                <PhLast />
              </div>
              <div className="w-full md:w-6/12 lg:w-4/12 p-4">
                <CondLast />
              </div>
              <div className="w-full md:w-6/12 lg:w-4/12 p-4">
                <TdsLast />
              </div>
              <div className="w-full md:w-6/12 lg:w-4/12 p-4">
                <OrpLast />
              </div>
              <div className="w-full md:w-6/12 lg:w-4/12 p-4">
                <OxygenLast />
              </div>
              <div className="w-full md:w-6/12 lg:w-4/12 p-4">
                <TempLast />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap">
          <div className=" w-full xl:w-4/12 px-4">
            <MainLastScore />
          </div>
          <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
            <MainGraphic />
          </div>
        </div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
            <AllLastDosage />
          </div>
          <div className="w-full xl:w-4/12 px-4">
            <TankStatus />
          </div>
        </div>
      </>
    )
  }
}
const mapStateToProps = state => {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, { isLogged })(Dashboard);